import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Tooltip } from '@material-ui/core';
import '../TestSeriesList/testSeriesList.scss';
import { useSelector, useDispatch } from 'react-redux';
import { getTestSeries } from 'examsbook-react-sdk/actions/getTestSeries';
import ReleasePlanModel from "../ReleasePlan/ReleasePlanModel";
import TestSeriesCardButtonGroup from "./TestSeriesCardButtonGroup";
import TestSeriesCardKeyPoints from "./TestSeriesCardKeyPoints";
import { useTranslations, useUserLanguage } from "examsbook-react-sdk/custom-hooks";
import { reactGaEvent } from "examsbook-react-sdk/actions/Common";
import { useNavigate } from "react-router-dom";

/**
 * Test series card
 * @param props
 * @returns {*}
 * @constructor
 */
function TestSeriesCard(props) {
    const [ addReleaseModal, setAddReleaseModal ] = useState(false);
    const { testData } = props;
    const navigate = useNavigate();
    const t = useTranslations();
    const { language } = useUserLanguage();
    const dispatch = useDispatch();
    const dataStatus = useSelector((state) => state.testSeries.status);
    const testSeries = useSelector((state) => state.testSeries && state.testSeries.testSeries ? state.testSeries.testSeries : {});

    function handleGoToTestClick() {
        reactGaEvent("Test Series", "Go To Test");
        navigate('/my-app/test-series/' + testData._id + '/tests');
    }

    function openModal() {
        dispatch(getTestSeries(testData._id));
        setAddReleaseModal(true);
    }

    function closeModal() {
        setAddReleaseModal(false);
    }

    let imageJpg;
    if (testData.featured) {
        imageJpg = testData.featured.thumbnail.jpg;
    }

    return (
        <div className="card-list" onClick={handleGoToTestClick}>
            <NavLink to={'/my-app/test-series/' + testData._id + '/tests'}>
                <img
                    src={imageJpg} alt={imageJpg} onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/img/test-series-error.jpg";
                }}/>

                <Tooltip placement="top-start" title={testData.name} aria-label={testData.name}>
                    <h4 className="tool-tip">{testData.name}</h4>
                </Tooltip>

            </NavLink>

            <p className="test-availability">{!testData.totalTest ? t('no_test') : testData.totalTest + ' ' + t('total_test')}
                <span onClick={openModal}>{t('Release_Plan')}</span>
            </p>

            {
                testSeries && testSeries.quizGroup && testSeries.quizGroup.length ?
                    <ReleasePlanModel testSeries={testSeries} lang={language} open={addReleaseModal}
                                      closeModal={closeModal} dataStatus={dataStatus}/> :
                    <ReleasePlanModel testSeries={testSeries} lang={language} open={addReleaseModal}
                                      closeModal={closeModal} dataStatus={dataStatus}/>
            }
            <TestSeriesCardKeyPoints sections={testData.sections} keyPoints={testData.keypoints}/>
            <TestSeriesCardButtonGroup t={t} testData={testData}/>
        </div>

    );
}

export default TestSeriesCard;
